/* ==================================================================
   SAMEDI, REVIEWS PAGE (round 52, 23 Sep 2026)

   Two jobs, nothing else:
     1. turn the star breakdown into a filter, without a page reload
     2. open the list at 8 reviews with a "show more"

   Progressive enhancement. The markup ships with every review visible,
   the filter buttons `disabled` and the "show more" button `hidden`,
   so with this file blocked or failed the page is still a complete,
   readable list. Nothing here reads, writes, adds or reorders a
   review: it only sets the `hidden` attribute on list items that are
   already in the page.
   ================================================================== */
(function () {
  'use strict';

  var PAGE = 8;

  var list = document.querySelector('[data-srv-list]');
  var bars = document.querySelector('[data-srv-bars]');
  if (!list || !bars) return;

  var items = Array.prototype.slice.call(list.querySelectorAll('[data-srv-item]'));
  var barBtns = Array.prototype.slice.call(bars.querySelectorAll('[data-srv-bar]'));
  var hint = document.querySelector('[data-srv-hint]');
  var stateTxt = document.querySelector('[data-srv-state]');
  var clearBtn = document.querySelector('[data-srv-clear]');
  var moreBtn = document.querySelector('[data-srv-more]');
  var noneMsg = document.querySelector('[data-srv-none]');

  if (!items.length) return;

  var active = null;   // null = no filter, otherwise the chosen rating as a number
  var shown = PAGE;    // how many of the matching reviews are on screen

  function matching() {
    if (active === null) return items;
    return items.filter(function (el) {
      return el.getAttribute('data-stars') === String(active);
    });
  }

  function plural(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 's');
  }

  function render() {
    var hits = matching();

    items.forEach(function (el) { el.hidden = true; });
    hits.slice(0, shown).forEach(function (el) { el.hidden = false; });

    barBtns.forEach(function (b) {
      var on = active !== null && Number(b.getAttribute('data-stars')) === active;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    if (active === null) {
      stateTxt.textContent = 'All ' + plural(items.length, 'review');
    } else {
      stateTxt.textContent = 'Showing ' + plural(hits.length, 'review') +
        ' rated ' + active + ' star' + (active === 1 ? '' : 's');
    }

    if (clearBtn) clearBtn.hidden = active === null;
    if (noneMsg) noneMsg.hidden = hits.length !== 0;

    if (moreBtn) {
      var left = hits.length - shown;
      moreBtn.hidden = left <= 0;
      if (left > 0) {
        moreBtn.textContent = 'Show ' + Math.min(left, PAGE) + ' more review' +
          (Math.min(left, PAGE) === 1 ? '' : 's');
      }
    }
  }

  function setFilter(stars) {
    active = stars;
    shown = PAGE;
    render();
  }

  barBtns.forEach(function (b) {
    // a rating nobody has given stays inert: there is nothing to show
    if (Number(b.getAttribute('data-count')) > 0) b.disabled = false;

    b.addEventListener('click', function () {
      var v = Number(b.getAttribute('data-stars'));
      setFilter(active === v ? null : v);   // clicking the chosen one again clears it
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      setFilter(null);
      var first = barBtns.filter(function (b) { return !b.disabled; })[0];
      if (first) first.focus();   // keyboard focus has somewhere to land
    });
  }

  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var before = matching().slice(0, shown).length;
      shown += PAGE;
      render();
      var next = matching()[before];
      if (next) {
        // move reading position to the first newly revealed review
        next.setAttribute('tabindex', '-1');
        next.focus({ preventScroll: true });
      }
    });
  }

  if (hint) hint.hidden = false;
  render();
})();
